export interface ApplicationCreationResponse {
    applicationId: number | null;
    status: ApplicationCreationStatus;
}

export enum ApplicationCreationStatus {
    Success = 1,
    CallSignNotFound = 2,
    /**
     * This value is interpreted in the UI only and is used to handle
     * applications that take an extended time to create.
     */
    Timeout = 999,
}
